import { VisibilityUserSettings } from "../constants/online.homepagegateway.api"

export interface TimeRangeFilter {
  dateField: string
  timeRange: string
}

/**
 * Converts user settings to TimeRangeFilter format
 * @param userSettings The visibility user settings from the API
 * @returns TimeRangeFilter with timeRange and dateField
 */
export const mapUserSettingsToTimeRangeFilter = (
  userSettings: VisibilityUserSettings
): TimeRangeFilter => {
  return {
    timeRange: userSettings.preferredTimeFrame || '',
    dateField: userSettings.preferredSortCriteria?.ordersShipments || ''
  }
}